var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationwithbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Location"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#18173C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6953 4.5C10.945 4.50031 10.2022 4.64878 9.50951 4.93691C8.81679 5.22503 8.1878 5.64712 7.65864 6.17896C7.12948 6.7108 6.71056 7.34191 6.42594 8.03607C6.14131 8.73023 5.99658 9.47376 6.00006 10.224C6.00006 14.1792 10.0801 17.8056 11.3353 18.7656C11.4406 18.8526 11.573 18.9002 11.7097 18.9002C11.8463 18.9002 11.9787 18.8526 12.0841 18.7656C13.3417 17.7768 17.3881 14.1792 17.3881 10.224C17.3915 9.47397 17.2469 8.73063 16.9624 8.03662C16.6779 7.34262 16.2592 6.71162 15.7303 6.17981C15.2014 5.648 14.5727 5.22586 13.8803 4.9376C13.1878 4.64933 12.4453 4.50062 11.6953 4.5ZM11.6953 12.5904C11.2206 12.5904 10.7566 12.4496 10.3619 12.1859C9.96721 11.9222 9.6596 11.5474 9.47795 11.1088C9.2963 10.6703 9.24877 10.1877 9.34138 9.72218C9.43398 9.25663 9.66256 8.82899 9.9982 8.49334C10.3339 8.1577 10.7615 7.92912 11.227 7.83652C11.6926 7.74391 12.1752 7.79144 12.6137 7.97309C13.0522 8.15474 13.4271 8.46235 13.6908 8.85703C13.9545 9.25171 14.0953 9.71573 14.0953 10.1904C14.0953 10.8269 13.8424 11.4374 13.3923 11.8875C12.9422 12.3375 12.3318 12.5904 11.6953 12.5904Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationwithbg);
export default __webpack_public_path__ + "static/media/locationwithbg.85145cfaca45b28d8cf3bb3543ec4e40.svg";
export { ForwardRef as ReactComponent };